














import Vue from "vue";

import iwInputCalendar from "@/encoding/components/buildingBlocks/InputCalendar.vue";

import moment from "moment";

export default Vue.extend({
    components: {
        iwInputCalendar: iwInputCalendar
    },
    data: function() {
        return {
            pathInStore: "transaction.availabilityDate",
            today: moment().format("YYYY-MM-DD") as string,
        };
    },
    computed: {
        availabilityDate: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) || this.today;
        },
        availabilityPeriodType: function(): string {
            return this.$store.getters["FormModule/getValue"]("transaction.availabilityPeriodType");
        },
        isDisplayed: function(): boolean {
            const isDisplayed = this.availabilityPeriodType === "ON_THE_DATE";
            if (!isDisplayed) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            }
            return isDisplayed;
        }
    },
    watch: {
        isDisplayed: function(value) {
            if (value) {
                this.updateAvailabilityDate(this.availabilityDate);
            }
        }
    },
    methods: {
        updateAvailabilityDate: function (value: string) {
            this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": value});
        },
    },
});
